import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { DELETE, GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    blog: {},
    blogList: [],
    loading: {},
    error: null
};

export const blogSlice = createSlice({
    name: "blogSlice",
    initialState: init,
    reducers: {
        setBlog: (state, action) => {
            state.blog = action.payload;
        },

        setBlogs: (state, action) => {
            state.blogList = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch data list
        .addCase(fetchBlogList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchBlogList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.blogList = action.payload;
        })
        .addCase(fetchBlogList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add blog
        .addCase(addBlog.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addBlog.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.blog = action.payload;
        })
        .addCase(addBlog.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update blog
        .addCase(updateBlog.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateBlog.fulfilled, (state, action) => {
            state.loading.saving = false;
            // state.blog = action.payload;
        })
        .addCase(updateBlog.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })
        
        // Delete Blog
        .addCase(deleteBlog.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(deleteBlog.fulfilled, (state, action) => {
            state.loading.fetching = false;
            // state.blog = action.payload;
        })
        .addCase(deleteBlog.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        });
    }
});

export const fetchBlogList = createAsyncThunk(
    "productSlice/fetchBlogList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/blogs`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch data");
        }
    }
);

export const updateBlog = createAsyncThunk(
    "blogSlice/updateBlog",
    async ({ blogId, blogData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/blogs/${blogId}`, blogData);
            dispatch(fetchBlogList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update blog");
        }
    }
);

export const addBlog = createAsyncThunk(
    "blogSlice/addBlog",
    async ({ blogData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/blogs`, blogData);
            dispatch(fetchBlogList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add blog");
        }
    }
);


export const deleteBlog = createAsyncThunk(
    "blogSlice/deleteBlog",
    async ({ blogId, blogData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(DELETE, `${API_ROUTE}/blogs/${blogId}`, blogData);
            dispatch(fetchBlogList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update blog");
        }
    }
);

export const { clearData, setBlog, setBlogs } = blogSlice.actions;

export default blogSlice.reducer;
